export default {
  path: '',
  component: () => import(`@/component/admin-layout/index.vue`),
  children: [
    {
      path: '/admin/sample-data-list',
      name: 'admin-sample-data-list',
      component: () => import(`./index.vue`),
      meta: {
        entity_for_history_tag: {
          name: `示例数据`,
        },
        entity_list_for_breadcrumb: [
          {name: `示例功能`},
          {name: `示例数据`},
        ],
      },
    }
  ],
};
